export default __webpack_public_path__ + "assets/star-component.e1a3ffaa.svg";